/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Tea_Grade_Delete_Blocked_SortingInputs */

const vi_tea_grade_delete_blocked_sorting = /** @type {(inputs: Tea_Grade_Delete_Blocked_SortingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} lô phân loại`)
};

/**

* @param {Tea_Grade_Delete_Blocked_SortingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_grade_delete_blocked_sorting = /** @type {((inputs: Tea_Grade_Delete_Blocked_SortingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Grade_Delete_Blocked_SortingInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_grade_delete_blocked_sorting(inputs)
});